import React, { Fragment, useState } from 'react';
import Header from '../../components/Header/Header';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/business/Footer/Footer';
import Bg from '../../images/backgrounds/onze_diensten_image.webp';
import srImg from '../../images/services/quickscan/quickscan_info.webp';
import {Accordion, AccordionBody, AccordionHeader, AccordionItem} from "reactstrap";
import CtaSection from "../../components/CtaSection/CtaSection";


const steps = [
    {
        id: 1,
        title: "Ondersteunen van dienstverlening",
        description: "MSP's bieden cruciale IT-diensten aan bedrijven. Wij ondersteunen MSP’s door ervoor te zorgen dat hun klanten beschikken over robuuste en betrouwbare cybersecurity-oplossingen.",
    },
    {
        id: 2,
        title: "Vertrouwen opbouwen",
        description: "Cybersecurity is essentieel voor de reputatie van een MSP. Door samen te werken met Praeventor, kunnen MSP’s klanten overtuigen van hun vermogen om geavanceerde beveiliging te leveren.",
    },
    {
        id: 3,
        title: "Efficiëntie en schaalbaarheid",
        description: "Onze oplossingen helpen MSP’s om processen te stroomlijnen en diensten uit te breiden naar meer klanten zonder in te boeten op kwaliteit.",
    },
];

const MSPPage = (props) => {

    const [activeStep, setActiveStep] = useState(1);

    const handleStepClick = (stepId) => {
        setActiveStep(stepId);
    };

    const [open, setOpen] = useState('1');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };

    return (
        <Fragment>
            <Header />
            <main className="page_content about-page">
                <PageTitle pageTitle={'Waarom richten wij ons op MSP’s?'} bgImage={Bg} />
                <section className="about_section section_space bg-light">
                    <div className="container">
                        <div className="row align-items-center justify-content-lg-between">
                            <div className="col-lg-5 order-lg-first">
                                <div className="team_cartoon_image">
                                    <img src={srImg} alt="Service Cartoon"/>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <div className="sectoren_content">
                                    <div className="heading_block">
                                        <h2 className="heading_text">
                                            Cybersecurity en Compliance op maat voor MSP’s
                                        </h2>
                                        <p className="heading_description mb-0">
                                            Managed Service Providers (MSP's) staan voor de uitdaging om hun klanten hoogwaardige IT-oplossingen te bieden in een tijdperk van toenemende cyberdreigingen. Bij Praeventor begrijpen we dat MSP's betrouwbare, schaalbare en efficiënte oplossingen nodig hebben om zowel zichzelf als hun klanten te beschermen. Wij bieden technologieën en ondersteuning die aansluiten bij de unieke behoeften van MSP’s, zodat zij hun dienstenportefeuille kunnen uitbreiden en excelleren in een concurrerende markt.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <div className="pt-130"></div>

                {/* Focusgebieden */}
                <section className="section_space bg-white">
                    <div className="container">
                        <h3 className="text-center mb-5">De uitdagingen voor MSP’s</h3>
                        <p className="heading_description mb-5 pb-80">
                            Onze keuze om ons op MSP’s te richten is gebaseerd op de specifieke obstakels waar deze IT-dienstverleners dagelijks mee te maken hebben:
                        </p>
                        <div className="partners_faq accordion" id="partners_faq">
                            <Accordion open={open} toggle={toggle} className="accordion" id="service_process_faq">
                                <AccordionItem className="accordion-item">
                                    <AccordionHeader targetId="1">
                                        Toenemende verwachtingen van klanten
                                    </AccordionHeader>
                                    <div className="accordion-body-container">
                                        <AccordionBody accordionId="1" className="acc_body">
                                            <p>
                                                Klanten verwachten dat MSP’s niet alleen hun IT beheren, maar ook geavanceerde beveiliging bieden. Het bijbenen van deze eisen zonder specialistische ondersteuning kan een uitdaging zijn.
                                            </p>
                                        </AccordionBody>
                                    </div>
                                </AccordionItem>

                                <AccordionItem className="accordion-item">
                                    <AccordionHeader targetId="2">
                                        Behoefte aan schaalbare oplossingen
                                    </AccordionHeader>
                                    <div className="accordion-body-container">
                                        <AccordionBody accordionId="2" className="acc_body">
                                            <p>
                                                MSP's bedienen vaak een diverse klantenkring met uiteenlopende behoeften. Het vinden van beveiligingsoplossingen die flexibel genoeg zijn om aan al deze eisen te voldoen, is essentieel.
                                            </p>
                                        </AccordionBody>
                                    </div>
                                </AccordionItem>

                                <AccordionItem className="accordion-item">
                                    <AccordionHeader targetId="3">
                                        Cyberdreigingen evolueren voortdurend
                                    </AccordionHeader>
                                    <div className="accordion-body-container">
                                        <AccordionBody accordionId="3" className="acc_body">
                                            <p>
                                                Hackers richten zich steeds vaker op de klanten van MSP’s. Dit stelt extra eisen aan de beveiligingsmaatregelen en de snelheid waarmee bedreigingen worden opgespoord en opgelost.
                                            </p>
                                        </AccordionBody>
                                    </div>
                                </AccordionItem>

                                <AccordionItem className="accordion-item">
                                    <AccordionHeader targetId="4">
                                        Naleving van regelgeving
                                    </AccordionHeader>
                                    <div className="accordion-body-container">
                                        <AccordionBody accordionId="4" className="acc_body">
                                            <p>
                                                MSP's moeten voldoen aan strikte eisen zoals AVG (GDPR) en NIS2. Praeventor helpt deze naleving eenvoudiger en efficiënter te maken, zodat MSP’s zich kunnen concentreren op hun kernactiviteiten.
                                            </p>
                                        </AccordionBody>
                                    </div>
                                </AccordionItem>
                            </Accordion>
                        </div>
                    </div>
                </section>

                {/*  Waarom kiezen MSP's voor ons?  */}
                <section className="about_section section_space bg-light">
                    <div className="container">
                        <div className="row align-items-center justify-content-lg-between" style={{ padding: "100px"}}>
                            <div className="col-lg-12">
                                <div className="sectoren_content">
                                    <div className="heading_block">
                                        <h2 className="heading_text text-center">
                                            Waarom kiezen MSP’s voor Praeventor?
                                        </h2>
                                        <p className="heading_description mb-0 text-center">
                                            Wij richten ons op MSP’s omdat we begrijpen dat zij de ruggengraat vormen van IT-dienstverlening voor bedrijven. Onze oplossingen zijn ontworpen om hun werk eenvoudiger, veiliger en effectiever te maken, zodat zij kunnen blijven excelleren in hun dienstverlening.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="process_technology_review_section section_decoration">
                    <div className="container">
                        <div className="heading_block mb-5">
                            <h2 className="heading_text mb-0">
                                Wat maakt <mark>MSP’s</mark> aantrekkelijk voor ons?
                            </h2>
                        </div>

                        <div className="steps_container">
                            {steps.map((step, index) => (
                                <div
                                    key={step.id}
                                    className={`step_item ${activeStep === step.id ? 'active' : ''}`}
                                    onClick={() => handleStepClick(step.id)}
                                    style={{
                                        backgroundColor: activeStep === step.id ? '#f0f0f5' : 'white',
                                        border: '1px solid #e0e0e0',
                                        padding: '20px',
                                        marginBottom: '20px',
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        transition: 'background-color 0.3s ease',
                                    }}
                                >
                                    <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#2c3e50' }}>
                                        {`${step.id}. ${step.title}`}
                                    </div>
                                    <div style={{ marginTop: '10px', color: '#555' }}>
                                        {activeStep === step.id && <p>{step.description}</p>}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
                <CtaSection />
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    );
};

export default MSPPage;
